export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/Discover/theme/components/scorecard/ScorecardView/ScorecardExport.js